import axios from 'axios'
import store from '../vuex'
import { TOKEN, validExist, parseQueryParamsByUrl } from '@/utils'

let requestUtils = (baseURL) => {
    const instance = axios.create({
        baseURL,
        // 超时时间 16 秒
        timeout: 16000,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    })

    // 请求拦截器 添加token， 判断登录之类操作
    instance.interceptors.request.use(
        config => {
            const { headers, url } = config
            const code = parseQueryParamsByUrl(
                window.location.href,
                'code'
            )
            if (code && code !== 'undefined') {
                headers['token'] = code
            } else {
                if (validExist()) {
                    headers['token'] = sessionStorage.getItem(TOKEN)
                } else {
                    if (!['/check', '/loginByAccount'].includes(url)) {
                        window.location.href = '/'
                        return undefined
                    }
                }
            }

            return config
        },
        error => {
            return Promise.reject(error)
        }
    )

    // 响应拦截器，对返回数据进行预处理
    instance.interceptors.response.use(
        response => {
            return response
        },
        error => {
            return Promise.reject(error)
        }
    )
    /**
     * 对 请求进行封装 只有 status 与 code 都是200 才会进入 then , 否则均进入 catch
     * @param {*} options
     */
    const request = (options = {}) => {
        return new Promise((resolve, reject) => {
            instance(options)
                .then(({ data, status, statusText }) => {
                    if (status === 200) {
                        if (data.constructor === Blob) {
                            resolve(data)
                        } else {
                            const { code, msg, data: response } = data
                            if (code === 0) {
                                resolve(response)
                            } else if (code === 400) {
                                store.commit('logout')
                                window.location.href = '/'
                            } else {
                                reject(msg)
                            }
                        }

                    } else {
                        reject(statusText)
                    }
                })
                .catch(result => {
                    if (result) {
                        const {
                            response: { status, statusText, data = {} }
                        } = result
                        switch (status) {
                            case 401:
                                reject('未授权')
                                break
                            case 403:
                                reject('登录失效')
                                break
                            case 404:
                                reject('访问异常，请联系系统管理员')
                                break
                            default:
                                reject(data.message || statusText)
                                break
                        }
                    } else {
                        reject(result)
                    }
                })
        })
    }

    const get = (url, params = {}) => {
        return request({
            url,
            method: 'get',
            params
        })
    }

    const put = (url, data = {}) => {
        return request({
            url,
            method: 'put',
            data
        })
    }

    const post = (url, data = {}) => {
        return request({
            url,
            method: 'post',
            data
        })
    }

    const del = (url, data = {}) => {
        return request({
            url,
            method: 'delete',
            data
        })
    }

    return {
        get,
        post,
        del,
        put,
        request
    }
}


export const { del, get, post, put, request } = requestUtils('manager')



// WEBPACK FOOTER //
// ./src/api/request.js